import { useCallback } from 'react';
import useDispatch from "../../../hooks/useDispatch";
import { UnknownDeleteRequirementAttachmentError, useCheckRequirementStatus, useDeleteRequirementAttachments } from "../../../data";
export var useRefreshRequirementStatus = function useRefreshRequirementStatus() {
  var _useCheckRequirementS = useCheckRequirementStatus(),
    checkRequirementStatus = _useCheckRequirementS.checkRequirementStatus,
    isCheckingRequirementStatus = _useCheckRequirementS.isCheckingRequirementStatus,
    checkRequirementStatusError = _useCheckRequirementS.checkRequirementStatusError;
  var dispatch = useDispatch();
  var refreshRequirementStatus = useCallback(function (params, callbacks) {
    checkRequirementStatus({
      requirementId: params.requirementId
    }, {
      onSuccess: function onSuccess(data) {
        dispatch({
          type: 'PAYMENT_REQUIREMENT_NEW_STATUS',
          requirementId: params.requirementId,
          status: data.status,
          orderId: data.orderId
        });
        if (callbacks.onSuccess) {
          callbacks.onSuccess();
        }
      },
      onError: function onError(error) {
        if (callbacks.onError) {
          callbacks.onError(error);
        }
      }
    });
  }, [checkRequirementStatus, dispatch]);
  return {
    refreshRequirementStatus: refreshRequirementStatus,
    isRefreshingRequirementStatus: isCheckingRequirementStatus,
    refreshRequirementStatusError: checkRequirementStatusError
  };
};
export var useDeleteAndRefreshRequirementAttachments = function useDeleteAndRefreshRequirementAttachments() {
  var _useDeleteRequirement = useDeleteRequirementAttachments(),
    deleteRequirementAttachments = _useDeleteRequirement.deleteRequirementAttachments,
    deleteRequirementAttachmentsError = _useDeleteRequirement.deleteRequirementAttachmentsError,
    isDeletingRequirementAttachments = _useDeleteRequirement.isDeletingRequirementAttachments;
  var dispatch = useDispatch();
  return {
    deleteRequirementAttachments: useCallback(function (params, options) {
      deleteRequirementAttachments({
        attachmentIds: params.attachmentIds,
        requirementId: params.requirementId,
        applicationId: params.applicationId
      }, {
        onSuccess: function onSuccess(_ref) {
          var successfullyDeletedAttachmentIds = _ref.successfullyDeletedAttachmentIds,
            requirementStatus = _ref.requirementStatus;
          dispatch({
            type: 'DELETE_REQUIREMENT_ATTACHMENTS',
            requirementAttachmentIds: successfullyDeletedAttachmentIds,
            requirementStatus: requirementStatus,
            requirementId: params.requirementId,
            requirementType: params.requirementType
          });
          options.onSuccess();
        },
        onError: function onError(err) {
          if (err instanceof UnknownDeleteRequirementAttachmentError && err.successfullyDeletedAttachmentIds.length > 0) {
            dispatch({
              type: 'DELETE_REQUIREMENT_ATTACHMENTS',
              requirementAttachmentIds: err.successfullyDeletedAttachmentIds,
              requirementStatus: err.requirementStatus,
              requirementId: params.requirementId,
              requirementType: params.requirementType
            });
          }
          options.onError(err);
        }
      });
    }, [deleteRequirementAttachments, dispatch]),
    deleteRequirementAttachmentsError: deleteRequirementAttachmentsError,
    isDeletingRequirementAttachments: isDeletingRequirementAttachments
  };
};
export { UnknownDeleteRequirementAttachmentError };